function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.11111111,4.6 L6.11111111,3 L3,5.8 L6.11111111,8.6 L6.11111111,6.96 C8.33333333,6.96 9.88888889,7.6 11,9 C10.5555556,7 9.22222222,5 6.11111111,4.6 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "-Working",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Offers-History",
  transform: "translate(-786.000000, -523.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(786.000000, 523.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,0 C2.90976562,0 0,2.90976562 0,6.5 C0,10.0902344 2.90976562,13 6.5,13 C10.0902344,13 13,10.0902344 13,6.5 C13,2.90976563 10.0902344,0 6.5,0 Z",
  id: "Path",
  fill: "#FF6600",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "icon/content/reply_24px",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}))));

var SvgReplyArrowFilledOrange = function SvgReplyArrowFilledOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplyArrowFilledOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reply-arrow-filled-orange.a54d35b4.svg";
export { ForwardRef as ReactComponent };